













import Vue from 'vue';

import { FAKE_MOVIES } from '../../../config';
import ShowListItem from './show-list-item.vue';

export default Vue.extend({
  name: 'ShowList',

  components: {
    ShowListItem,
  },

  data: () => ({
    shows: FAKE_MOVIES,
  }),
});
